import { createPaymentListContainer } from './container'
import { PaymentList as PaymentListUI } from './ui/payment-list'

export const PaymentList = createPaymentListContainer(PaymentListUI)
